import axiosClient from "./axiosClient";

const exportService = {
  exportComplete: async (studyId) => {
    const response = await axiosClient.get(`/export/complete/${studyId}`, {
      responseType: "blob", 
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Export_Complet.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  exportSimple: async (studyId) => {
    const response = await axiosClient.get(`/export/simple/${studyId}`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Export_Simple.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};

export default exportService;
